import { useCallback, useContext, useState } from "react";
import GlobalContext from "../../context/GlobalContext";
import DataTableComponent from "./DataTableComponent";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit, faTrash } from "@fortawesome/free-solid-svg-icons";
import { useNavigate } from "react-router-dom";
import swal from "../../services/swalConfig";
import CopyText from "../utilities/CopyText";
import { deleteSchedule, fetchSchedules } from "../../api/ScheduleApi";

import { tr } from "../../i18n";
const TableSchedules = ({ refresh }) => {
  const { user, setLoading } = useContext(GlobalContext);
  const [reload, setReload] = useState(0);
  const navigate = useNavigate();
  const [editData, setEditData] = useState(null);

  const fetchData = useCallback(
    async ({ page, perPage, search }) => {
      if (!user?.workspace?.company_id) return { data: [], total: 0 }; // Hindari request jika company_id belum tersedia

      const response = await fetchSchedules({
        companyId: user.workspace.company_id,
        page,
        perPage,
        search,
      });

      const numberedData = response.data.map((item, index) => ({
        ...item,
        no: (page - 1) * perPage + index + 1,
      }));

      return { data: numberedData, total: response.total };
    },
    [user, reload, refresh] // Tambahkan dependency agar berubah saat user berubah
  );

  const handleEdit = (data) => {
    navigate(`/schedules/form?edit=${data.id}`, { state: data });
  };

  const handleDelete = async (id) => {
    const result = await swal.fire({
      title: tr("shared:are_you_sure"),
      text: tr("attendance:you_want_to_delete_this_template"),
      icon: "warning",
      showCancelButton: false,
      confirmButtonText: tr("shared:i_understand_delete"),
      confirmButtonColor: "#f10f29ff",
      cancelButtonText: tr("common:actions.cancel"),
      timer: false,
    });

    if (result.isConfirmed) {
      processDelete(id);
    }
  };

  const processDelete = async (id) => {
    try {
      setLoading(true);

      const data = {
        company_id: user.workspace.company_id,
        id: id,
      };

      const response = await deleteSchedule(data);

      if (response.status == 200) {
        swal.fire({
          title: tr("shared:success"),
          text: response.message,
          icon: "success",
          showCancelButton: false,
        });

        setReload((prev) => prev + 1);
      } else {
        swal.fire({
          title: tr("common:errors.oops"),
          text: response.message,
          icon: "error",
          showCancelButton: false,
        });
      }
    } catch (error) {
      swal.fire({
        title: tr("common:errors.oops"),
        text: tr("common:errors.generic"),
        icon: "error",
        showCancelButton: false,
      });
    } finally {
      setLoading(false);
    }
  };

  const columns = [
    { name: tr("shared:no"), selector: (row) => row.no, width: "70px", sortable: true },
    {
      name: "ID",
      cell: (row) => <CopyText text={row.id} />,
      sortable: true,
      wrap: true,
      width: "15%",
    },
    {
      name: tr("shared:name"),
      selector: (row) => row.template_name,
      sortable: true,
      wrap: true,
      width: "25%",
    },
    {
      name: tr("shared:time_zone"),
      selector: (row) => row.time_zone,
      sortable: true,
      wrap: false,
    },
    {
      name: tr("shared:actions"),
      center: true,
      cell: (row) => (
        <div style={{ display: "flex", gap: "10px" }}>
          <button
            onClick={() => handleEdit(row)}
            className="btn btn-primary btn-sm"
          >
            <FontAwesomeIcon icon={faEdit} className="me-1" /> {" "}{tr("common:breadcrumb.edit")}
          </button>
          <button
            onClick={() => handleDelete(row.id)}
            className="btn btn-danger btn-sm"
          >
            <FontAwesomeIcon icon={faTrash} className="me-1" /> {" "}{tr("common:actions.delete")}
          </button>
        </div>
      ),
      width: "40%",
      style: {
        justifyContent: "center",
        alignItems: "center",
        display: "flex",
      },
    },
  ];

  return (
    <div>
      <DataTableComponent columns={columns} fetchData={fetchData} />
    </div>
  );
};

export default TableSchedules;
